
import React from 'react';

const ScopeOfApplication = () => {
  return (
    <div>
      <h3 className="text-xl font-semibold mb-3">I. Scope of application</h3>
      <div className="space-y-4">
        <p className="text-gray-600">This Privacy Policy:</p>
        <ul className="list-disc pl-6 space-y-2 text-gray-600">
          <li>describes how we collect, use, and handle personal data that you provide to us or that we collect from you when you access or use our website https://metrade.io including all its subdomains (hereinafter «Website») and our Mobile-App and Webapp (hereinafter collectively «App»);</li>
          <li>explains the circumstances under which we may disclose this personal data to third parties; and</li>
          <li>informs you about your rights in relation to your personal data.</li>
        </ul>
        <p className="text-gray-600">
          Our privacy policy applies in conjunction with all of our other legal notices or terms of use that appear elsewhere on our Website or are otherwise made available to you.
        </p>
      </div>
    </div>
  );
};

export default ScopeOfApplication;
